import request from '@/common/request'
import { ViewPerfil, ViewRelatorio } from '@/models/views/ViewRelatorio'

const basePath = '/views'

export const listarViews = (): Promise<ViewRelatorio[]> =>
	request.get(`${basePath}/listar`)

export const efetuarConsultaRelatorio = (idView: string, params?: any): Promise<object[]> =>
	request.get(`${basePath}/${idView}`, {
		params,
	})

export const listarViewPorPerfil = (idPerfil: string): Promise<ViewPerfil[]> =>
	request.get(`${basePath}/perfil/${idPerfil}/listar`)

export const salvarViewPerfis = (viewPerfis: ViewPerfil[]): Promise<void> =>
	request.post(`${basePath}/perfil/salvar`, viewPerfis)

export const listarViewsPorPerfil = (idPerfil: string): Promise<ViewRelatorio[]> =>
	request.get(`${basePath}/listar/${idPerfil}`)